import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=040af77a&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=040af77a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040af77a",
  null
  
)

export default component.exports